var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightedEventCardBottomIllus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 68,
    viewBox: "0 0 220 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 30C57.943 10.9316 42.4905 47.4401 0 68H220V0C179.5 33.5 161 36.6005 134.5 30Z",
    fill: "#FCCE2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedEventCardBottomIllus);
export default __webpack_public_path__ + "static/media/highlighted-event-card-bottom-illus.9206d4359c4d89f2c83c7462668b6216.svg";
export { ForwardRef as ReactComponent };